import React, { useState } from "react";
import "./AuthScreen.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const AuthScreen = ({ onAuth }) => {
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regUsername, setRegUsername] = useState("");
  const [regFullName, setRegFullName] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regConfirm, setRegConfirm] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem("zanox_token", data.token);
        localStorage.setItem("zanox_username", data.user.username);
        localStorage.setItem("zanox_email", data.user.email);
        onAuth(data.token, data.user.username);
      } else {
        setError(data.error || "Login failed");
      }
    } catch (err) {
      setError("Connection failed. Is the backend running?");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    if (regPassword !== regConfirm) {
      setError("Passwords do not match");
      return;
    }

    if (regPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    if (regUsername.length < 3) {
      setError("Username must be at least 3 characters");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: regEmail,
          username: regUsername,
          fullName: regFullName,
          password: regPassword,
        }),
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem("zanox_token", data.token);
        localStorage.setItem("zanox_username", data.user.username);
        localStorage.setItem("zanox_email", data.user.email);
        onAuth(data.token, data.user.username);
      } else {
        setError(data.error || "Registration failed");
      }
    } catch (err) {
      setError("Connection failed. Is the backend running?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="cosmic-rings">
        <div className="ring ring-1"></div>
        <div className="ring ring-2"></div>
        <div className="ring ring-3"></div>
      </div>

      <div className="auth-card">
        <div className="auth-header">
          <i className="fas fa-infinity"></i>
          <h1>ZANOX</h1>
          <p>{mode === "login" ? "Return to truth" : "Begin your journey"}</p>
        </div>

        {mode === "login" ? (
          <form onSubmit={handleLogin} className="auth-form">
            <div className="input-group">
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                className="auth-input"
                autoFocus
              />
            </div>

            <div className="input-group">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="auth-input"
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  <span>Sign In</span>
                </>
              )}
            </button>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="auth-form">
            <div className="input-group">
              <i className="fas fa-user"></i>
              <input
                type="text"
                value={regFullName}
                onChange={(e) => setRegFullName(e.target.value)}
                placeholder="Full name"
                className="auth-input"
                autoFocus
              />
            </div>

            <div className="input-group">
              <i className="fas fa-at"></i>
              <input
                type="text"
                value={regUsername}
                onChange={(e) => setRegUsername(e.target.value)}
                placeholder="Username"
                className="auth-input"
              />
            </div>

            <div className="input-group">
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                value={regEmail}
                onChange={(e) => setRegEmail(e.target.value)}
                placeholder="Email address"
                className="auth-input"
              />
            </div>

            <div className="input-group">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                value={regPassword}
                onChange={(e) => setRegPassword(e.target.value)}
                placeholder="Password (6+ characters)"
                className="auth-input"
              />
            </div>

            <div className="input-group">
              <i className="fas fa-lock"></i>
              <input
                type="password"
                value={regConfirm}
                onChange={(e) => setRegConfirm(e.target.value)}
                placeholder="Confirm password"
                className="auth-input"
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                <>
                  <i className="fas fa-user-plus"></i>
                  <span>Create Account</span>
                </>
              )}
            </button>
          </form>
        )}

        <div className="auth-switch">
          {mode === "login" ? (
            <span>
              No account?{" "}
              <button onClick={() => { setMode("register"); setError(""); }}>Register</button>
            </span>
          ) : (
            <span>
              Already registered?{" "}
              <button onClick={() => { setMode("login"); setError(""); }}>Sign In</button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;
